const getPatientCityStateZip = ({ patient, value, billing = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = billing ? patient['Billing Address Information'] : patient['Address Information'];
  if (address && address.City) {
    return `${address.City}, ${address.State} ${address['Zip Code']}`.toUpperCase();
  }
  return null;
};

export default getPatientCityStateZip;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientCityStateZip.js